import {
  gmail1,
  gmail2,
  gmail3,
  gmail4,
  outlook1,
  outlook2,
  outlook3,
} from "../../../../../assets/integration/Email_Instructions";

export const MailBoxFeatures = [
  {
    id: 1,
    content:
      "Save your time by checking emails and replying to customers directly from Tidio",
  },
  {
    id: 2,
    content:
      "Keep your Inbox organized by separating chats from emails and plan your daily work",
  },
  {
    id: 3,
    content:
      "Treat emails as tickets – set their priorities and handle yourself in a proper time or assign to your colleagues",
  },
  {
    id: 4,
    content:
      "Know what’s up with each customer requests thanks to statuses and assignees",
  },
];

export const EmailInstructions = [
  {
    id: 1,
    desc: `Select the Gear icon from the top right corner of your Google mail dashboard and choose "Settings"`,
    img: gmail1,
    copyEmail: false,
  },
  {
    id: 2,
    desc: `
    Choose the "Forwarding and POP/IMAP" tab in the settings and click on the "Add a forwarding address" button in the middle.`,
    img: gmail2,
    copyEmail: false,
  },
  {
    id: 3,
    desc: `
    Copy the following email address and paste it in the "Please enter a new forwarding email address:" field and click on the "Next button"`,
    img: gmail3,
    copyEmail: true,
  },
  {
    id: 4,
    desc: `Please wait for a confirmation email and click on the Verification link to activate the forwarding.
    Also, make sure that you have selected the "Forward a copy of incoming mail to..." checkbox in your Forwarding settings in Gmail.`,
    img: gmail4,
    copyEmail: false,
  },
];

export const OutlookInstructions = [
  {
    id: 1,
    desc: `Select the Gear icon from the top right corner of your Inbox and choose "Options"`,
    img: outlook1,
    copyEmail: false,
  },
  {
    id: 2,
    desc: `
    From the Options page, click on "Forwarding" tab in "Account" section`,
    img: outlook2,
    copyEmail: false,
  },
  {
    id: 3,
    desc: `
    Copy the following email address and paste it in the "Forward my email to:" field and click on the "Save" button.`,
    img: outlook3,
    copyEmail: true,
  },
];
